export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tvbet.vue?vue&type=template&id=0d34dfab&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/tvbet.vue?vue&type=template&id=0d34dfab&scoped=true
// module id = 64+Q
// module chunks = 0